











































































import { Component, Prop, Vue } from "vue-property-decorator";
import { IShareInfo } from "../api/types";
import native from "@/common/Native";
import { wxChatJumpApp } from "@/common/wechatapp";
import request from "@/api/newchongqing/index";
import { findNameByAppconfig, findNameByWechatAppid } from "@/common/Utils";
@Component({})
export default class AppPrompt extends Vue {
  @Prop()
  private shareInfo!: IShareInfo;
  @Prop()
  private newsDetail!: any;
  @Prop()
  private infoClassifyid!: string;
  @Prop()
  private infoClassifyId!: string;
  @Prop()
  private appId!: string | number;
  @Prop({ default: "1" }) //问政sourceType 2
  private sourceType!: string | number;

  private isOpenInApp: boolean = false;
  private isYbp: string = "0";
  private isShowAppPromt: boolean = true;
  private isScreenNews: boolean = true; //是否是短视频  是短视频openapp要浮在顶上, 不是短视频不能浮在顶上遮住别的文字

  isLink = false; // 是否在微信唤醒后台配置了当前域名
  isShowWXbtn = false; // 是否显示微信标签的唤醒按钮
  extinfo: any = ""; // 唤醒APP参数
  openWxAppId = ""; // 唤醒APP参数 应用的appid
  configId = ""; //  唤醒APP参数 a值

  openhdstatic: any; // 是否显示头部唤醒 - 最高优先级  1显示  2不显示
  async created() {
    this.openhdstatic =
      (this.$route.query.openhdstatic as string) == "2"
        ? (this.isShowAppPromt = false)
        : (this.isShowAppPromt = true);
    // wxChatJumpApp();
    let appInfo = this.$store.state.appInfo;
    this.openWxAppId = findNameByWechatAppid(
      appInfo,
      this.appId || (this.$route.query.appId as string)
    );
    let appConfig = findNameByAppconfig(
      appInfo,
      this.appId || (this.$route.query.appId as string)
    );
    this.openWxAppId = appConfig.wechatAppid;
    this.configId = appConfig.wechatConfigId;

    let linkUrl = window.location.href;
    if (
      linkUrl &&
      appConfig.realmUrl &&
      linkUrl.indexOf(appConfig.realmUrl) != -1
    ) {
      this.openWxAppId;
      this.isShowWXbtn = true;
      this.$route.path == "/screen/screen-video"
        ? (this.isShowWXbtn = false)
        : (this.isShowWXbtn = true);
    } else {
      this.isShowWXbtn = false;
    }
  }
  mounted() {
    // 在微信外不显示按钮
    if (this.isWexin()) {
      this.isShowWXbtn = true;
    } else {
      this.isShowWXbtn = false;
    }
    this.isYbp = this.$route.query.isYbp as string; // 是否是在阅报屏中打开的 （在阅报屏中打开即是不在端内，但是不能显示app头部提示）
    this.isOpenInApp = native.isOpenInApp();
    this.isScreenNewsDetail();
    const videoFormat = this.$route.path == "/video/vertical-video" ? 2 : -1;
    const contextType = this.$route.path == "/video/vertical-video" ? 5 : 1;
    const url =
      this.$route.path == "/video/vertical-video"
        ? this.newsDetail.contentUrl
        : window.location.href;

    let params = {
      contextType: contextType, // contextType 竖版视频传5  多图新闻传1 其他的也传1
      detailViewType: "2", // 写死传2
      id: this.infoClassifyid || this.infoClassifyId, //新闻id
      videoFormat: videoFormat, //  videoFormat竖屏新闻传2  别的为-1
      shareUrl: url, //新闻url
      url: url, // 新闻url
      sourceId: this.newsDetail.id, // sourceId
      sourceType: this.sourceType, // sourceType空字符串
      thirdUrlEncode: false,
      title: this.newsDetail.title, // title空字符串
      shareTitle: "", // shareTitle空字符串
      urlType: "1" // 1 新闻; 2 活动;   都传string
    };
    this.extinfo = JSON.stringify(params);
    // console.log(this.extinfo);
  }
  closeAppPrompt() {
    this.isShowAppPromt = false;
  }
  openApp() {
    let newsId = this.infoClassifyid || this.infoClassifyId;
    const shareInfo = this.shareInfo;
    if (!shareInfo.schemeUrl) {
      return (location.href = shareInfo.downloadUrl);
    }
    let schemeUrl = shareInfo.schemeUrl.split("/");
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      const videoFormat = this.$route.path == "/video/vertical-video" ? 2 : -1;
      const Params = {
        id: newsId,
        sourceId: this.newsDetail.informationId,
        sourceType: this.sourceType,
        url: location.href,
        shareUrl: location.href,
        videoFormat: videoFormat, // videoFormat 竖屏新闻传2  别的为-1
        urlType: "1" // 1 新闻; 2 活动;   都传string
      };
      location.href = `${shareInfo.schemeUrl}/info/install/${this.appId}.html?id=${newsId}&&&sourceId=${this.newsDetail.informationId}&&&sourceType=${this.sourceType}&&&url=${location.href}&&&shareUrl=&&&videoFormat=${videoFormat}`;
    } else if (/(Android)/i.test(navigator.userAgent)) {
      const videoFormat = this.$route.path == "/video/vertical-video" ? 2 : -1;
      const Params = {
        id: newsId,
        sourceId: this.newsDetail.informationId,
        sourceType: this.sourceType,
        url: location.href,
        shareUrl: location.href,
        videoFormat: videoFormat, // videoFormat 竖屏新闻传2  别的为-1
        urlType: "1" // 1 新闻; 2 活动;   都传string
      };
      // alert(JSON.stringify(Params));
      location.href = schemeUrl[2] + `://?params=${JSON.stringify(Params)}`;
      setTimeout(() => {
        location.href = shareInfo.downloadUrl;
      }, 3000);
    } else {
      location.href = shareInfo.downloadUrl;
    }
  }
  // 判断是否是短视频
  isScreenNewsDetail() {
    let path = this.$route.path;
    // url上带有 screen/screen-video
    path == "screen/screen-video"
      ? (this.isScreenNews = true)
      : (this.isScreenNews = false);
  }

  // 判断是否在微信内
  isWexin() {
    const ua = window.navigator.userAgent.toLowerCase();
    const isWeixin = ua.indexOf("micromessenger") != -1;
    if (isWeixin) {
      return true;
    } else {
      return false;
    }
  }
  // wx标签初始化完毕，可以进行点击操作
  handleReadyFn(e: any) {
    console.log("初始化成功", e);
  }
  // wx标签用户点击跳转按钮并对确认弹窗进行操作后触发
  handleLaunchFn(e: any) {
    console.log("success", e);
    console.log("app-prompt1111");
  }
  // wx标签用户点击跳转按钮后出现错误
  handleErrorFn(e: any) {
    console.log("fail", e.detail);
    console.log(e);
    console.log("如果是没安装应用, 则跳转下载页");
    // launch:fail ⽤失败，或安卓上该应用未安装，或iOS上用户在弹窗上点击确认但该应⽤未安装
    this.openApp();
  }
}
